<template>
    <div class="page page__has-bar">
        <div class="page__bd">
            <div class="weui-cells">
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">客户编号</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ form.main.cun_cucode }}
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">客户名称</label>
                    </div>
                    <div class="weui-cell__bd">
                        {{ form.main.cun_cuname }}
                    </div>
                </div>
                <date-field label="截止回款日" v-model="form.main.cun_enddate" />
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label for class="weui-label">解挂原因</label>
                    </div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="text" v-model="form.main.cun_remark" placeholder="请填写" />
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bar weui-dialog__ft">
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="$router.back()">取消</a>
        </div>
    </div>
</template>

<script>
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";

export default {
    mixins: [process],
    components: {
        DateField
    },
    data() {
        return {
            baseUrl: "/api/document/customerunlock",
            codeField: "cun_cucode",
            caller: "CustomerUnlock",
            xtype: 'document-customer-unlockPanel',
            form: {
                main: {}
            }
        };
    },
    methods: {
        save() {
            var me = this,
                main = me.form.main
            if (!main.cun_enddate) {
                me.$weui.topTips("请选择截止回款日期", 2000);
            } else if (!main.cun_remark) {
                me.$weui.topTips("请填写解挂原因", 2000);
            } else {
                me.f_save(res => {
                    var ret = res.data;
                    // 保存即自动提交流程
                    if (ret && ret.hasProcess) {
                        if (ret.processStarted) {
                            me.$weui.toast("解挂流程发起成功", 2000);
                            me.$router.back();
                        } else {
                            me.preLaunchProcess(
                                me.caller,
                                ret.doc,
                                me.xtype,
                                () => me.$router.back()
                            );
                        }
                    } else {
                        me.$weui.toast("解挂成功", 2000);
                        me.$router.back();
                    }
                });
            }
        }
    },
};
</script>